'use client'

import { confirm } from '@repo/ui/Confirm'
import { MoreVertIcon } from '@repo/ui/MoreVertIcon'
import { PopupWithBackdrop } from '@repo/ui/PopupWithBackdrop'
import { useMenuState, MenuItem } from '@szhsin/react-menu'
import { useRef } from 'react'
import { useThirdPartyCaseTypesStore } from '@repo/store/useThirdPartyCaseTypesStore'
import { useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'

export const MoreMenuCard = ({ rowData, setRunFetch }: MoreMenuCardProps) => {
  const [menuState, toggleMenu] = useMenuState({ transition: true })
  const { deleteNewMatterDefault, fetchSingleNewMatterDefault } = useThirdPartyCaseTypesStore()

  const ref = useRef(null)
  const navigate = useNavigate()

  const handleEditClick = async () => {
    try {
      await fetchSingleNewMatterDefault({ newMatterDefaultId: rowData.newMatterDefaultId })
    } catch (error) {
      console.error('Error setting new matter default data:', error)
    } finally {
      navigate(
        '?wizard=PerfectPortal-CaseType&stage=perfect-portal-case-type&step=add-new-case-type-details&editCaseTypeMapping=true'
      )
    }
  }

  const handleDeleteClick = async () => {
    const proceed = await confirm('Are you sure you want to delete this field mapping?')
    if (!proceed) return

    proceed && (await deleteNewMatterDefault({ newMatterDefaultId: rowData.newMatterDefaultId }))

    setRunFetch((prev) => !prev)

    toggleMenu(false)
  }

  return (
    <MUIStack data-testid="MoreMenuCard">
      <IconButton onClick={() => toggleMenu(true)} ref={ref}>
        <MoreVertIcon sx={{ height: '20px', width: '20px' }} />
      </IconButton>

      <PopupWithBackdrop
        menuState={menuState}
        anchorRef={ref}
        toggleMenu={toggleMenu}
        className="caseTypeActionMoreMenu"
      >
        <MenuItem onClick={handleEditClick}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </PopupWithBackdrop>
    </MUIStack>
  )
}

type MoreMenuCardProps = {
  setRunFetch: React.Dispatch<React.SetStateAction<boolean>>
  rowData: {
    branchDescription: string
    branchId: number
    departmentDescription: string
    departmentId: number
    feeEarnerDescription: string
    feeEarnerId: string
    matterDescription: string
    newMatterDefaultId: number
    notificationRecipientEmailAddress: string
    notificationRecipientUserId: string
    notificationSourceId: string
    notificationSourceName: string
    sourceWorkTypeId: string
    sourceWorkTypeName: string
    supervisingFeeEarnerDescription: string
    supervisingFeeEarnerId: string
    workTypeDescription: string
    workTypeId: string
  }
}
